export function getView(httpMethod) {
  return ['post', 'put', 'patch'].includes(httpMethod)
}
